import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Nav from '../components-public/Nav'
import Footer from '../components-public/Footer'
import { usePublicPosts } from '../hooks/usePosts'
import { estimateReadTime } from '../lib/helpers'

export default function BlogListPage() {
  const { posts, loading } = usePublicPosts(20)

  return (
    <>
      <Helmet>
        <title>Blog | Orken Tecnologia</title>
        <meta name="description" content="Artigos e insights sobre tecnologia, gestão pública e privada." />
      </Helmet>
      <Nav />
      <main style={{ paddingTop: 104 }}>
        <div className="section">
          <div className="section-inner">
            <div className="section-eyebrow">Blog</div>
            <h1 className="section-title">Artigos e insights sobre tecnologia e gestão</h1>

            {loading && (
              <div className="grid gap-6" style={{ maxWidth: 800 }}>
                {[1,2,3].map(i => (
                  <div key={i} className="blog-card" style={{ padding: 32 }}>
                    <div style={{ height: 24, width: '60%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 12 }} />
                    <div style={{ height: 16, width: '100%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 8 }} />
                    <div style={{ height: 16, width: '80%', background: 'var(--bg-2)', borderRadius: 4 }} />
                  </div>
                ))}
              </div>
            )}

            <div className="grid gap-6" style={{ maxWidth: 800 }}>
              {posts.map((p) => (
                <Link to={`/blog/${p.slug}`} key={p.id} style={{ textDecoration: 'none' }}>
                  <article className="blog-card" style={{ padding: 32 }}>
                    <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>{p.title}</h3>
                    <p style={{ fontSize: 14, color: 'var(--text-dim)', lineHeight: 1.65, marginBottom: 16 }}>{p.excerpt}</p>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                        {p.published_at ? new Date(p.published_at).toLocaleDateString('pt-BR') : new Date(p.created_at).toLocaleDateString('pt-BR')}
                        {' · '}{estimateReadTime(p.content)} min de leitura
                      </span>
                      {(p.tags || []).map(t => <span className="case-tag" key={t}>{t}</span>)}
                    </div>
                  </article>
                </Link>
              ))}
              {!loading && posts.length === 0 && (
                <p style={{ color: 'var(--text-muted)' }}>Nenhum artigo publicado ainda.</p>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}
